import(/* webpackMode: "eager" */ "/codebuild/output/src789774232/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
